// src/utils/postEncounterDocument.js
// Generates a formatted plain-text post-encounter checklist report

import { POST_ENCOUNTER_SCENARIOS, SHARED_SECTIONS } from '../data/postEncounterData';
import i18n from '../i18n';

function formatDate(date) {
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}

function formatTime(date) {
  return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
}

export function generatePostEncounterReport(branchId, checkedItems) {
  const t = i18n.t.bind(i18n);
  const branch = POST_ENCOUNTER_SCENARIOS.find((b) => b.id === branchId);
  if (!branch) return '';

  const branchChecked = checkedItems[branchId] || {};
  const allSections = [...branch.sections, ...SHARED_SECTIONS];
  const lines = [];
  const divider = '\u2500'.repeat(56);
  const heavyDivider = '\u2550'.repeat(56);

  lines.push(heavyDivider);
  lines.push('        POST-ENCOUNTER GUIDE \u2014 CHECKLIST');
  lines.push('        SafeNeighbor \u2014 Know Your Rights');
  lines.push(heavyDivider);
  lines.push('');

  const now = new Date();
  lines.push(`Report Created: ${formatDate(now)} at ${formatTime(now)}`);
  lines.push(`Scenario: ${t(branch.title)}`);
  lines.push('');

  for (const section of allSections) {
    const sectionChecked = branchChecked[section.id] || [];
    lines.push(divider);
    lines.push(t(section.title));
    lines.push(divider);

    if (section.content) {
      lines.push(`  ${t(section.content)}`);
      lines.push('');
    }

    // Checklist items
    if (section.checklist) {
      section.checklist.forEach((item, idx) => {
        const checked = sectionChecked.includes(idx);
        lines.push(`  ${checked ? '[x]' : '[ ]'} ${t(item)}`);
      });
      lines.push('');
    }

    // Info points (for court-rights section)
    if (section.infoPoints) {
      for (const point of section.infoPoints) {
        lines.push(`  \u2022 ${t(point)}`);
      }
      lines.push('');
    }

    // Hotlines
    if (section.hotlines && section.hotlines.length > 0) {
      lines.push('  Key Numbers:');
      for (const h of section.hotlines) {
        lines.push(`    ${h.name}: ${h.number}`);
      }
      lines.push('');
    }

    // Links
    if (section.links && section.links.length > 0) {
      lines.push('  Resources:');
      for (const link of section.links) {
        lines.push(`    ${link.name}: ${link.url}`);
      }
      lines.push('');
    }
  }

  // Footer
  lines.push(heavyDivider);
  lines.push('Share this checklist with your attorney and trusted contacts.');
  lines.push(heavyDivider);
  lines.push('Generated by SafeNeighbor \u2014 safeneighbor-33bb0.web.app');
  lines.push('This is not legal advice. Consult a licensed attorney.');
  lines.push(divider);

  return lines.join('\n');
}
